import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ExtensionProvider = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "forge-extension-provider" */ './extension-provider')),
    LoadingSkeleton: () => null,
});
